/**
 * 为API注册请求函数，将所有API合并到一个Class实例
 * Example：
 * 1. 注册所有api
 * const server = new Server()
 * server.parseRouter('user',
 *      {
 *        login: '/user/login',
 *        createUser: { method: 'post', url: '/user/create'}
 *      }
 * )
 * 2. 调用
 * server.user.login({name: 'lisa', password: '123'})
 * server.user.createUser({name: 'lisa', gender: 'female'})
 */
import request from './request'

function Server () {
  this._request = request
}

/**
 * 为各个api模块注册api函数
 * @param {string} name : 模块名称
 * @param {*} urlObj
 */
Server.prototype.parseRouter = function (name, urlObj) {
  this[name] = []
  Object.keys(urlObj).forEach(apiName => {
    this[name][apiName] = this.sendMsg.bind(this, urlObj[apiName])
  })
}

/**
 * 为指定的api绑定request函数
 * @param {*} url ：api的url串或对象{ method, url }
 * @param {*} data ：api参数
 * @param {*} config ：可选配置，参照axios的配置
 * @returns ： Promise
 */
Server.prototype.sendMsg = function (url, data = {}, config = {}) {
  // 设置vue实例，可以在此设置通用的变量，如loading
  const instance = this.instance ? this.instance.$data : null
  instance && (instance.loading = true)

  const method = url.method || 'get'
  url = parseUrl(url, data)
  const dataObj = method.toLowerCase().trim() === 'get' ? { params: data } : { data }

  const requestParams = {
    method,
    url,
    ...config,
    ...dataObj
  }

  const defaultFn = (response) => {
    instance && (instance.loading = false)
    return response.data
  }

  const errorFn = error => {
    instance && (instance.loading = false)
    return Promise.reject(error)
  }

  return this._request(requestParams).then(defaultFn).catch(errorFn)
}

/**
 * 设置当前Vue组件实例
 * @param {*} instance ： 当前Vue对象
 */
Server.prototype.setInstance = function (instance) {
  this.instance = instance
}

const parseUrl = (url, data) => {
  let tmpUrl = url.url || url
  if (tmpUrl.indexOf('{') > -1) {
    Object.keys(data).forEach(key => {
      const reg = new RegExp('{' + key + '}', 'g')
      tmpUrl = tmpUrl.replace(reg, data[key])
    })
  }
  return tmpUrl
}

export default new Server()
